import React, { FC } from 'react';
import classNames from 'classnames';
import { useQuery } from '@apollo/client';
import { Outlet, useLocation, useParams } from 'react-router-dom';

import Container from 'components/common/Container';
import EventPageHeader from 'components/headers/EventPageHeader';
import { EventContextProvider } from 'components/context/EventContext';

import { GET_EVENT } from 'graphql/queries/events';

import { EventLayoutProps } from './interfaces';

import useStyles from './style';

const EventLayout: FC<EventLayoutProps> = ({ className, isLoading = false }) => {
  const classes = useStyles();

  const { id: eventId } = useParams<keyof EventPageRouteParams>();
  const { pathname } = useLocation();
  const isTimeline = pathname.includes('timeline');

  const { data, error, loading } = useQuery<EventResponse>(GET_EVENT, {
    variables: { eventId },
    fetchPolicy: 'cache-and-network',
    skip: !eventId,
  });

  const event = data?.event;

  if (error || (loading && !event)) {
    return null;
  }

  return (
    <div
      className={classNames(classes.eventLayout, className, {
        isTimeline,
      })}
      id="eventLayout"
    >
      <EventContextProvider value={{ isLoading: loading || isLoading, event }}>
        <EventPageHeader />
        <Container
          className={classNames('eventLayoutContainer content-fade-in', {
            ready: !!event && !loading,
          })}
        >
          {!!event && !loading ? <Outlet /> : null}
        </Container>
      </EventContextProvider>
    </div>
  );
};

export default EventLayout;
